import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "@/locales/en.json";
import cn from "@/locales/cn.json";

Vue.use(VueI18n);

const messages = {
  en: en,
  cn: cn,
};

const savedLocale = localStorage.getItem("locale") || "en";

const i18n = new VueI18n({
  locale: savedLocale, // set default locale from localStorage
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
